import { render, staticRenderFns } from "./expenses.vue?vue&type=template&id=af2f6a16&scoped=true&"
import script from "./expenses.vue?vue&type=script&lang=js&"
export * from "./expenses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af2f6a16",
  null
  
)

export default component.exports